import $ from "jquery/dist/jquery";

$(() => {
    $(document).on('submit', '.singleSubmitForm', () => {
        $(this).find('button, input[type="submit"]').prop('disabled', true);
        $(this).addClass('singleSubmitForm-loading');
    });
});
